<template>
  <div>
    <figure class="my-code">
      <figcaption>Payload</figcaption>
      <pre><code datatype="JSON">{{ JSON.stringify(step, null, 2) }}</code></pre>
    </figure>
    <ButtonDefault
      style="height: 34px; width: 100%;"
      title="Próximo"
      @click="proximo"
    />
  </div>
</template>
<script>
import ButtonDefault from '@/components/buttons/ButtonDefault'

export default {
  name: 'TemplateStepDefault',
  components: { ButtonDefault },
  props: {
    step: {
      type: Object
    },
    titulo: {
      type: String
    },
    idFuncionalidade: {
      type: [Number, String],
      default: -23
    },
    data: {
      default: () => ({})
    }
  },
  methods: {
    proximo () {
      const payloadStep = {}
      this.$emit('proximo', payloadStep)
    }
  }
}
</script>
<style scoped>
</style>
